import NotFoundPage from '@public/components/Error/ErrorPage';

const Custom404 = () => {
  return <NotFoundPage errorCode="404" />;
};

export default Custom404;
